import { LayoutGridAuto } from 'breeze-intelligence-kit';
import { MatchRateCardEnrichable } from './MatchRateCardEnrichable';
import { MatchRateCardEligible } from './MatchRateCardEligible';
import { MatchRateCardSelected } from './MatchRateCardSelected';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MatchRateCards = ({
  isContactEnrichment,
  isLoading,
  recordsEligible,
  recordsEnrichable,
  recordsSelected
}) => /*#__PURE__*/_jsxs(LayoutGridAuto, {
  alignItems: "stretch",
  autoRepeat: "auto-fit",
  flex: "1 1 100%",
  maxInlineSize: "70ch",
  minWidth: "10rem",
  children: [/*#__PURE__*/_jsx(MatchRateCardSelected, {
    count: recordsSelected,
    isContactEnrichment: isContactEnrichment,
    isLoading: isLoading
  }), /*#__PURE__*/_jsx(MatchRateCardEligible, {
    count: recordsEligible,
    isContactEnrichment: isContactEnrichment,
    isLoading: isLoading
  }), /*#__PURE__*/_jsx(MatchRateCardEnrichable, {
    count: recordsEnrichable,
    isContactEnrichment: isContactEnrichment,
    isLoading: isLoading
  })]
});